// extracted by mini-css-extract-plugin
export default {"root":"menuButton_root__k7wFE","menu":"menuButton_menu__aHj28"};